var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCurrentEscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9918 0C9.22678 0 0.5 8.72678 0.5 19.4918V20.5082C0.5 31.2732 9.22678 40 19.9918 40C30.7568 40 39.4836 31.2732 39.4836 20.5082V19.4918C39.4836 17.8815 39.2883 16.3169 38.9202 14.8202L19.9918 23.2219L28.3936 12.9786L34.9047 6.93975C31.3291 2.69611 25.9753 0 19.9918 0Z",
    fill: "#EE4322"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.11273,
    y: 5.72595,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L39.5 2.5",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrentEscape);
export default __webpack_public_path__ + "static/media/icon-current-escape.b57650486c1ef0e8a097452d40911c96.svg";
export { ForwardRef as ReactComponent };